/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyTravel,
    JsonEventPartyTravelFromJSON,
    JsonEventPartyTravelFromJSONTyped,
    JsonEventPartyTravelToJSON,
} from './JsonEventPartyTravel';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyTravel
 */
export interface ApiResultOfJsonEventPartyTravel {
    /**
     * 
     * @type {JsonEventPartyTravel}
     * @memberof ApiResultOfJsonEventPartyTravel
     */
    data?: JsonEventPartyTravel;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyTravel
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyTravel
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyTravel
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyTravel
     */
    result?: ApiResultOfJsonEventPartyTravelResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyTravelResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyTravelFromJSON(json: any): ApiResultOfJsonEventPartyTravel {
    return ApiResultOfJsonEventPartyTravelFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyTravelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyTravel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyTravelFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyTravelToJSON(value?: ApiResultOfJsonEventPartyTravel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyTravelToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

